var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasoleo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(8952 -323)",
    fill: "#36364a",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8952 323)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8949.323 -325.502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.567,19.549h2.676a5.021,5.021,0,0,1,2.56.465,1.649,1.649,0,0,1,.815,1.629c0,.815,0,.582-.116.815a.773.773,0,0,1-.465.582l-.7.349h0a2.464,2.464,0,0,1,.815.349,1.4,1.4,0,0,1,.582.582,2.5,2.5,0,0,1-.116,2.327,1.857,1.857,0,0,1-1.047.815,3.717,3.717,0,0,1-1.629.349H12.8V19.316Zm1.745,3.375H15.36c.465,0,.931,0,1.047-.233a.873.873,0,0,0,0-1.4,2.5,2.5,0,0,0-1.164-.233h-.931v1.862Zm0,1.4v2.211h1.164c.582,0,.931,0,1.164-.349s.349-.465.349-.815a.872.872,0,0,0-.116-.582c0-.116-.233-.233-.465-.349-.233,0-.465-.116-.931-.116Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.713,28.044l3.142-6.982H19.665V19.549h6.051v1.164l-3.258,7.331H20.713Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.193,6.982H8.611c-.349,0-.582-.233-.582-.7V3.142a.55.55,0,0,1,.582-.582H28.276c.931,0,1.047.116,1.047,1.047V6.051c0,.815-.116.931-.931.931H28.16V8.145h.815A2.2,2.2,0,0,1,31.3,10.473V26.415a2.411,2.411,0,0,1-3.142,2.444v1.28h0c1.047,0,1.164,0,1.164,1.28V33.28h4.887a.773.773,0,0,1,.465.582c0,.349-.116.582-.465.582H3.724q-1.047,0-1.047-.7c0-.465.349-.582,1.047-.582H8.029V31.3a1.3,1.3,0,0,1,1.164-1.4V6.982Zm1.28,23.273H26.647V18.269H10.473ZM26.764,16.989V6.982H10.589V16.989ZM9.193,3.84V5.7H27.927V3.84H9.193Zm0,27.695V33.28H27.927V31.535ZM28.044,15.709V27c0,.465.349.7.815.815a.921.921,0,0,0,.931-.582v-11.4H27.927Zm1.862-1.28V10.356c0-.465-.233-.815-.7-.815H28.044v5h1.862Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.618,15.709H12.684c-.815,0-.931-.116-.931-.931v-5.7c0-.7.233-.931.931-.931H24.669c.7,0,.931.233.931.931v5.818c0,.7-.233.815-.815.815H18.618Zm-5.585-1.28H24.2V9.542H13.033v4.887Z",
    fill: "#36364a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasoleo);
export default __webpack_public_path__ + "static/media/gasoleo.7f339158d750ad34d8ad4a1754c10445.svg";
export { ForwardRef as ReactComponent };